import React, { useState } from 'react';
import { Button, Alert, Spinner } from 'react-bootstrap';

const PaystackPayment = ({ 
  amount, 
  email, 
  onSuccess, 
  onClose, 
  disabled 
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePayment = () => {
    setIsProcessing(true);
    
    // Load Paystack script dynamically
    const script = document.createElement('script');
    script.src = "https://js.paystack.co/v1/inline.js";
    script.onload = () => {
      initializePayment();
    };
    document.body.appendChild(script);
  };

  const initializePayment = () => {
    const handler = window.PaystackPop.setup({
      key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
      email: email,
      amount: amount * 100, // Convert to kobo
      currency: 'NGN',
      ref: 'PS_' + Math.floor((Math.random() * 1000000000) + 1), // Generate a unique reference
      metadata: {
        custom_fields: [
          {
            display_name: "Payment For",
            variable_name: "payment_for",
            value: "Noureesh Foods Order"
          }
        ]
      },
      callback: function(response) {
        setIsProcessing(false);
        onSuccess(response);
      },
      onClose: function() {
        setIsProcessing(false);
        onClose();
      }
    });
    
    handler.openIframe();
  };

  return (
    <div>
      <Button
        variant="primary"
        onClick={handlePayment}
        disabled={disabled || isProcessing || !process.env.REACT_APP_PAYSTACK_PUBLIC_KEY}
        className="w-100 py-3"
      >
        {isProcessing ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Processing Payment...
          </>
        ) : (
          'Pay with Card'
        )}
      </Button>
      
      {!process.env.REACT_APP_PAYSTACK_PUBLIC_KEY && (
        <Alert variant="warning" className="mt-3">
          Paystack is not configured. Please set up your Paystack API keys.
        </Alert>
      )}
    </div>
  );
};

export default PaystackPayment;